import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TransactionStatusBadgeProps {
  success?: boolean | null;
  partialSuccess?: boolean;
  message?: string;
  status?: string;
  isAuthorised?: boolean;
}

function TransactionStatusBadge({
  success,
  partialSuccess,
  message,
  status,
  isAuthorised,
}: TransactionStatusBadgeProps) {
  const { t } = useTranslation();

  if (partialSuccess) {
    return <span className="badge bg-warning">{status}</span>;
  }

  if (isAuthorised === false && success === null) {
    return <span className="badge bg-info">{t('Pending authorisation')}</span>;
  }

  if (success == null) {
    return <span className="badge bg-info">{t('Processing')}</span>;
  }

  if (success) {
    return <span className="badge bg-success">{status}</span>;
  }

  return (
    <span className="badge bg-danger" title={message}>
      {status}
    </span>
  );
}

export default TransactionStatusBadge;
